import { render, staticRenderFns } from "./wechat------.vue?vue&type=template&id=9b5a92ae&scoped=true"
import script from "./wechat------.vue?vue&type=script&lang=js"
export * from "./wechat------.vue?vue&type=script&lang=js"
import style0 from "./wechat------.vue?vue&type=style&index=0&id=9b5a92ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5a92ae",
  null
  
)

export default component.exports